export default __webpack_public_path__ + "static/media/RomasFamous.cba22351.jpg";